import { api } from '../index';
import { TAxiosResponse } from '../baseApiTypes';

export const getAllPosts = (id:any): TAxiosResponse<any> =>
		id ? api.get(`/allposts?id=${id}`) : api.get(`/allposts`);
		
export const getBlogPosts = (id:any): TAxiosResponse<any> =>
		id ? api.get(`/blogposts?id=${id}`) : api.get(`/blogposts`);
		
export const AllPostsApi = {
  getAllPosts,
  getBlogPosts,
};
